import HtmlElement from './HtmlElement';
import {Settings} from '../Settings';
import {$body} from '../Constants';
import Header from '../Elements/Header';

/**
 * Javascript Wrapper for the Banner HTMLElement
 */
class Banner extends HtmlElement {
	onReady() {
		this.adjustHeight();
	}

	onResize() {
		this.adjustHeight();
	}

	adjustHeight() {
		if(Settings.bannerAdjust) {
			this.$element.css('margin-top', Header.getHeight());
		}
	}
}

export default (new Banner($body.find('.banner')));